(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-sku"] && !Shopify.designMode) return;
  try {
    class ProductSkuUpdater {
    constructor() {
      this.variantData = new Map();
      this.init();
    }

    init() {
      const skuElements = document.querySelectorAll('[data-product-sku-dynamic]');
      if (skuElements.length === 0) return;

      this.cacheVariantData(skuElements);
      this.setupEventListeners();
    }

    cacheVariantData(skuElements) {
      skuElements.forEach((element) => {
        const script = element.querySelector('script[data-product-variants]');
        if (script) {
          try {
            const data = JSON.parse(script.textContent);
            this.variantData.set(data.productId, data.variants);
          } catch (error) {
            console.warn('Error parsing variant data:', error);
          }
        }
      });
    }

    setupEventListeners() {
      document.querySelectorAll('variant-picker input[type="radio"], variant-picker select').forEach((input) => {
        input.addEventListener('change', this.handleVariantChange.bind(this));
      });
    }

    handleVariantChange(event) {
      let variantId = null;

      if (event.target.type === 'radio' && event.target.checked) {
        variantId = event.target.dataset.variantId || event.target.value;
      } else if (event.target.tagName === 'SELECT') {
        const option = event.target.options[event.target.selectedIndex];
        variantId = option?.dataset.variantId || option?.value;
      }

      if (variantId) {
        this.updateSku(variantId);
      }
    }

    updateSku(variantId) {
      this.variantData.forEach((variants, productId) => {
        const variant = variants.find((v) => v.id.toString() === variantId.toString());
        if (variant) {
          const element = document.querySelector(
            `[data-product-sku-dynamic][data-product-id="${productId}"] [data-product-sku-value]`
          );
          if (element) {
            element.textContent = variant.sku || 'No SKU';

            if (!variant.sku) {
              element.classList.add('product-sku__value--multiple');
            } else {
              element.classList.remove('product-sku__value--multiple');
            }
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductSkuUpdater());
  } else {
    new ProductSkuUpdater();
  }
  } catch(e) { console.error(e); }
})();

})();
